import * as moment from 'moment';
import { IReportingService } from '../../reporting/services/IReportingService';
import { IDownloadFileService } from '../../common/services/IDownloadFileService';
import { IAppSettings } from '../../common/configs/IAppSettings';
import { INotificationService } from "../../common/services/INotificationService";
import { IDialogService } from "../../common/services/IDialogService";
import { IFundingService } from "../Interfaces";
import { MedicareStatementSimple } from "../Models";

class ExpectedStatementBalanceComponent implements ng.IComponentOptions {
    public bindings: any = {
        monthAndYear: '=',
        statement: '='
    };

    public templateUrl: string = 'app/funding/partials/viewExpectedStatementBalances.html';

    public controller: any = class ExpectedStatementBalanceComponentController {
        static $inject = ["funding.service","reporting.service", "downloadFile.service", 
            "appSettings", "notification.service", "dialog.service", "data.service", "Upload", "facility.service"];
        public statement: any;
        public monthAndYear: string;
        public period: string;
        public selectedFacilityID: string;
        public selectedFacilityName: string;
        public uploadedFileName: string;
        public mode: string;
        public sheetData = [];
        medicareStatements: MedicareStatementSimple[];
        public isLoading: boolean;
        public expectedBalanceStatus: boolean;

        constructor(
            private readonly fundingService: IFundingService,
            private readonly reportingService: IReportingService,
            private readonly downloadFileService: IDownloadFileService,
            private readonly appSettings: IAppSettings,
            private readonly notificationService: INotificationService,
            private dialogService: IDialogService,
            private readonly dataService: any,
            private readonly upload: any,
            private readonly facilityService: any) {

            this.period = moment(this.monthAndYear, "MYYYY").format("MMMM YYYY");
            this.selectedFacilityName = this.facilityService.selectedFacility?.name;
            this.selectedFacilityID = this.facilityService.selectedFacility?.id;
            this.expectedBalanceStatus = false;
            this.mode = "";
            this.getMedicareEventLogByUniqueID();            
            this.isLoading = false;
           
        }

        private getMedicareEventLogByUniqueID = () => {
            var selectedMonth = this.monthAndYear.substring(0, 2);
            var selectedyear = this.monthAndYear.substring(2);
            var selectedstatment = selectedyear + "-" + selectedMonth + "-01";
            this.fundingService.medicareEventLogByUniqueid(selectedstatment, this.selectedFacilityID).then(response => {
                this.isLoading = false;
                this.expectedBalanceStatus = response;
                this.reportingService.getExpectedBalancesReportData(this.monthAndYear).then(response => {
                    this.isLoading = false;
                    this.sheetData = response
                    if (this.expectedBalanceStatus && this.sheetData && this.sheetData.length > 0) {
                        this.mode = "FinaliseBalance";
                    }
                    else if (!this.expectedBalanceStatus && this.sheetData && this.sheetData.length > 0) {
                        this.mode = "Upload";
                    }
                    else {
                        this.mode = "Download";
                    }
                }, () => {
                    this.notificationService.error("Unable to display statements month and year. Either your computer is offline, or Resident Manager is having problems of its own.");
                });
            }, () => {
                this.notificationService.error("balance finalise error. Either your computer is offline, or Resident Manager is having problems of its own.");
            });

        };

        public exportToExcel = () => {
            this.reportingService.getExpectedBalancesReportExcelStream(this.monthAndYear).then((response) => {
                let dateTime = new Date();
                let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
                this.downloadFileService.downloadFile(response, this.selectedFacilityName + " Balances" + ' - ' + dateTime.getFullYear() + '-' + month + '-' + dateTime.getDate() +
                    '_' + dateTime.getHours() + '.' + dateTime.getMinutes() + '.' + dateTime.getSeconds() + '.xlsx');
            });
        }

        public uploadBalanceStatement = (files) => {
            this.mode = "Upload";
            this.isLoading = true;
            if (!files || files.length === 0)
                return;

            let file = files[0];
            if (!file)
                return;
            this.isLoading = true;
            this.uploadedFileName = file.name;
            var baseUrl = this.appSettings.ApiUrl + "reporting/upload-balance-statement" + "?expectedMonthYear=" +
                encodeURIComponent(this.monthAndYear,) + "&fileName=" + encodeURIComponent(file.name);
            var url = this.dataService.addSelectedFacilityId(baseUrl);
           
            this.dataService.getHttpConfig()
                .then((config) => {
                    return this.upload.upload({
                        url: url,
                        method: "POST",
                        headers: config.headers,
                        file: file
                    }).then((resp) => {
                        this.sheetData = resp.data;
                        this.isLoading = false;
                    }, (errors) => {
                        this.isLoading = false;
                        this.dialogService.openMessageDialogwithClose("app/common/partials/confirmation-close-modal.html",
                            "Upload balances",
                            "Balances cannot be uploaded.<br/>" +"Valid template data must be used.",
                            "");
                    });
                });
        }

        public finaliseClaimExportToExcel = () => {
            this.reportingService.getFinaliseClaimBalancesReportExcelStream(this.monthAndYear, this.selectedFacilityName).then((response) => {
                const month = this.monthAndYear.slice(0, 2);
                const year = this.monthAndYear.slice(2);
                this.downloadFileService.downloadFile(response, this.selectedFacilityName + " Balances" + ' - ' + year + '-' + month + '.xlsx');
            });
        }
       
    }
}
export = ExpectedStatementBalanceComponent;